/**
 * @deprecated It is no longer necessary to call this function.  Web Analytics now automatically detects flags present in the DOM.
 */
export const injectFlags = (
  _params: { keys?: string[] } | undefined,
): void => {};
